import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TherapyService } from '../therapy.service';

@Component({
  selector: 'app-daily-tens-report',
  templateUrl: './daily-tens-report.component.html',
  styleUrls: ['./daily-tens-report.component.css']
})
export class DailyTensReportComponent implements OnInit {
  @Input('patient') patient: any;
  patientDailyTensReport: any;
  isLoading = true;
  hasReport: boolean = true;
  dataSourceOT: any = new MatTableDataSource([]);
  dataSourcePT: any = new MatTableDataSource([]);
  displayedColumnsPT: string[] = ['date_of_service','date_of_completion','results','summary'];
  displayedColumnsOT: string[] = ['date_of_service','date_of_completion','results','summary'];
  providerNameOT = '';
  providerNamePT = '';
  dataSourceOT1: any = [];
  dataSourcePT1: any = [];
  otResultsAndSummary = [];
  dob = '';
  constructor(private therapyService: TherapyService) { }

  async ngOnInit() {
    await this.getPatientTensReport();

  }
  async getPatientTensReport() {
    let patientName = this.patient.last_name + ', ' + this.patient.first_name.trim();
    this.therapyService.getPatientTensReport(patientName).subscribe(async (res: any) => {
      if (res.status == 200) {
        this.patientDailyTensReport = res.data.reports;
        this.dob = res.data.dob;
        this.hasReport = true;
        this.isLoading = false;
        this.normalizeReport(this.patientDailyTensReport);
      } else {
        console.log('something went wrong');
        this.isLoading = false;
        this.hasReport = false;
      }
    });
  }

  normalizeReport(reports) {
    let OccupationalTherapyTable = [];
    let PhysicalTherapyTable = [];
    for (let i = 0; i < reports.length; i++) {
      const element = reports[i];
      for (let ot = 0; ot < element.ot.length; ot++) {
        const ots = element.ot[ot];
        this.providerNameOT = ots.provider;
        ots.result = this.objectToString(ots.results);
        ots.summaryy = this.objectToString(ots.summary);
        OccupationalTherapyTable.push(ots);
        
      }
      for (let pt = 0; pt < element.pt.length; pt++) {
        let pts = element.pt[pt];
        this.providerNamePT = pts.provider;
        pts.result = this.objectToString(pts.results);
        pts.summaryy = this.objectToString(pts.summary);
        PhysicalTherapyTable.push(pts);
      }
    }
    console.log('OccupationalTherapyTable',OccupationalTherapyTable);
    console.log('PhysicalTherapyTable',PhysicalTherapyTable);
    
    this.dataSourceOT = OccupationalTherapyTable;
    this.dataSourcePT = PhysicalTherapyTable;

    this.dataSourceOT1 = OccupationalTherapyTable;
    this.dataSourcePT1 = PhysicalTherapyTable;
  }
  
  objectToString(arrayOfObjects) {
    let result = '';
    for (let index = 0; index < arrayOfObjects.length; index++) {
      const element = arrayOfObjects[index];
      for (const key in element) {
        if (Object.prototype.hasOwnProperty.call(element, key)) {
          const value = element[key];
          result += `<b>${key}</b> : ${value} <br>`;
        }
      }
    }
    return result;
  }

 }
